import ReactGA from 'react-ga';

export const enter = screen => {
  ReactGA.pageview(`/${screen}`);
};
